export default __webpack_public_path__ + "static/lxl-patrio-ca57a0077cc3f23abf3a6d41ed49fc7a.webp";